export function getClientMetricsCharts() {
  return {};
}

export function getClientMetricsChartOptions() {
  return [];
}
